{
  "data": {
    "arrayBuilderPatternFlowType": "optional",
    "arrayBuilderPatternInteractionType": "yesNoQuestion",
    "arrayBuilderItemPages": "complex",
    "arrayBuilderSummaryIntroVariation": "A",
    "view:hasEmployment": true,
    "employers": [
      {
        "dateRange": {
          "from": "1999-01-03",
          "to": "1999-01-03"
        },
        "name": "Employer 1",
        "address": {
          "view:militaryBaseDescription": {},
          "country": "USA",
          "street": "1234 Main St",
          "city": "City",
          "state": "AL",
          "postalCode": "12345"
        }
      },
      {
        "dateRange": {
          "from": "1999-01-03",
          "to": "1999-01-03"
        },
        "name": "Employer 2",
        "address": {
          "view:militaryBaseDescription": {},
          "country": "USA",
          "street": "1234 Main St",
          "city": "City",
          "state": "AL",
          "postalCode": "12345"
        }
      }
    ]
  }
}
